import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

import 'focus-visible/dist/focus-visible'

import { createMonitor } from './monitor'

createMonitor()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
